export default "/images/0b260a6362ac422a7b8a84a768e63fad.jpg";